import React from 'react';

import { Box, ButtonGroup } from '@mui/material';
import { useWatch } from 'react-hook-form';

import { FORM_FIELD_TYPES, FormField } from '../../../components/form/form-field';
import SaveButton from '../../../components/form/save-button';
import SchemaEditor from '../../../components/form/schema-editor';
import { useNodeContext } from '../../../context/node-context';

const SalesforceBulkReaderForm = ({ form, onSubmit, onChange }) => {
  const { errors } = form.formState;
  const formControl = form.control;
  const { node } = useNodeContext();
  const { id } = node;

  const useBearerToken = useWatch({
    control: formControl,
    name: 'properties.useBearerToken',
    defaultValue: false,
  });

  return (
    <Box
      component="form"
      onSubmit={form.handleSubmit(onSubmit)}
      onReset={form.reset}
      onChange={onChange}
    >
      <FormField
        controlId="salesforceBulkReaderFormName"
        label="name"
        name="name"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter name"
        required
        error={errors?.name?.message}
      />
      <FormField
        controlId="salesforceBulkReaderFormType"
        label="type"
        name="type"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        disabled
        error={errors?.type?.message}
      />
      <FormField
        controlId="salesforceBulkReaderFormDelayedRead"
        label="delayedRead"
        name="delayedRead"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.CHECKBOX}
      />
      <FormField
        controlId="salesforceBulkReaderFormParameterizedBy"
        label="parameterizedBy"
        name="parameterizedBy"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        error={errors?.parameterizedBy?.message}
      />
      <FormField
        controlId="salesforceBulkReaderFormFormat"
        label="format"
        name="format"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        error={errors?.format?.message}
      />

      <FormField
        controlId="salesforceBulkReaderFormUseBearerToken"
        label="useBearerToken"
        name="properties.useBearerToken"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.CHECKBOX}
        error={errors?.properties?.useBearerToken?.message}
      />
      {!useBearerToken && (
        <>
          <FormField
            controlId="salesforceBulkReaderFormUsername"
            label="username"
            name="properties.username"
            control={formControl}
            fieldComponentType={FORM_FIELD_TYPES.TEXT}
            placeholder="Enter Username"
            required
            error={errors?.properties?.username?.message}
          />
          <FormField
            controlId="salesforceBulkReaderFormPassword"
            label="password"
            name="properties.password"
            control={formControl}
            fieldComponentType={FORM_FIELD_TYPES.TEXT}
            type="password"
            placeholder="Enter Password"
            required
            error={errors?.properties?.password?.message}
          />
        </>
      )}
      <FormField
        controlId="salesforceBulkReaderFormIsSandbox"
        label="isSandbox"
        name="properties.isSandbox"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.CHECKBOX}
        error={errors?.properties?.isSandbox?.message}
      />
      <FormField
        controlId="salesforceBulkReaderFormQuery"
        label="query"
        name="properties.query"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.SPARKQL}
        placeholder="Enter Query"
        required
        rows={10}
        error={errors?.properties?.query?.message}
      />
      <FormField
        controlId="salesforceBulkReaderFormCharsToBeEncoded"
        label="charsToBeEncoded"
        name="properties.charsToBeEncoded"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter Characters to be Encoded"
        error={errors?.properties?.charsToBeEncoded?.message}
      />
      <SchemaEditor form={form} id={id} />
      <ButtonGroup>
        <SaveButton />
      </ButtonGroup>
    </Box>
  );
};

export default SalesforceBulkReaderForm;
